export default __webpack_public_path__ + "static/media/06-main.4a346f30.jpg";